export default __webpack_public_path__ + "static/media/dragon_win.03c3486a.gif";